// Chat Store Configuration - For Standalone Components
import { importProvidersFrom, isDevMode } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
// import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin'; // Disabled to prevent Angular DevTools conflicts
import { ChannelState } from './store/states/channel.state';
import { ChannelReadState } from './store/states/channel-read.state';
import { MessageState } from './store/states/message.state';
import { FileState } from './store/states/file.state';
import { MemberState } from './store/states/member.state';

export function provideChatStore() {
    return [
        importProvidersFrom(
            NgxsModule.forFeature([
                ChannelState,
                ChannelReadState,
                MessageState,
                FileState,
                MemberState,
            ]),
        ),

        // Storage Plugin for Persistence
        importProvidersFrom(
            NgxsStoragePluginModule.forRoot({
                keys: ['channels', 'channelReads', 'messages', 'files', 'members'], // States to persist
                storage: StorageOption.LocalStorage, // or 'sessionStorage'
                serialize: JSON.stringify,
                deserialize: JSON.parse,
            }),
        ),

        // Logger Plugin (only in development)
        importProvidersFrom(
            NgxsLoggerPluginModule.forRoot({
                disabled: !isDevMode(), // Disabled in production
                collapsed: true,
            }),
        ),

        // DevTools Plugin - DISABLED to prevent conflicts with Angular DevTools
        // importProvidersFrom(
        //     NgxsReduxDevtoolsPluginModule.forRoot({
        //         disabled: false,
        //         maxAge: 25,
        //     }),
        // ),
    ];
}
